import { defineComponent, getCurrentInstance, onBeforeMount, onMounted, reactive, ref, watch } from '@vue/composition-api'
import _ from 'lodash'
import { useSelector, useAsyncDispatch, useDispatch } from '@/utils/bhooks';
import './index.scss';
import i18n from '@/locales';
import { upload } from './upload.js';
import * as services from '@/services/auth'
import moment from 'moment';

const CommonTetxEdit = defineComponent({
  props: ['needDynamicEvent', 'initialData', 'placeholder', 'handleUpdate','formFocus'],
  setup(props, context) {
    const { app } = useSelector(({ app }) => ({ app }));
    const commit = useDispatch()
    const dispatch = useAsyncDispatch()
    const instance = getCurrentInstance()
    //i18n 国际化
    const tran = function (initParam) {
      return instance?.proxy.$t(initParam) as string
    }
    const { surveyDetail } = useSelector(({ surveyDetail }) => ({
      surveyDetail
    }))
    let editor: any
    let content = ref('')
    let closeInterval: any
    let needDynamicEvent = ref(props.needDynamicEvent || false)
    let initialData = ref(props.initialData || '')
    let placeholder = ref(props.placeholder || '')
    let mousePoint = ref('')
    let isShowCascader = ref(false)
    let dynamicEventsValue = ref([])
    let options = ref([])
    let domId = ref(`ID${moment().format('x')}${Math.floor(Math.random() * 100)}`)
    let qlpackId = ref(`qlID${moment().format('x')}${Math.floor(Math.random() * 100)}`)
    const clickToFocus = () => {
      // editor.config.language = 'en-US'
    }

    const triggleCascader = () => {
      // mousePoint.value = instance?.proxy?.$refs?.specialDom?.quill?.selection?.savedRange?.index
      mousePoint.value = editor.model.document.selection.getFirstPosition()
      isShowCascader.value = !isShowCascader.value
      if (!isShowCascader.value) {
        instance?.proxy?.$nextTick(() => {
          if (isShowCascader.value === true) {
            const ele = Array.prototype.slice.call(
              document.getElementsByClassName('qlCascader_certain')
            )
            ele?.forEach((item) => {
              item.focus()
            })
          }
        })
      }
    }

    const labelMouseDown = (e) => {
      e.preventDefault()
    }

    const handleDynamicEventsbBulr = (e) => {
      e.preventDefault()
      if (!e.relatedTarget) {
        setTimeout(() => {
          //点击开启按钮会有问题，才加的延时
          isShowCascader.value = false
        }, 100)
        // this.isShowCascader = false
      }
    }
    const handleDynamicEventsfocus = (e) => { }

    const handleDynamicEventsChange = (value, e) => {
      editor.model.change(writer => {
        editor.model.insertContent(writer.createText(value[1]), mousePoint.value);
      })
      // this.$emit('changeValue', this.content)
      isShowCascader.value = false
      dynamicEventsValue.value = []
      // instance?.proxy?.$refs?.specialDom?.quill.setSelection(
      //   content.value.length,
      //   content.value.length
      // )
      editor.focus()
    }

    const editBlur = (e) => {
      if (e.relatedTarget === document.getElementsByClassName('el-cascader-panel')[0]) {
        editor.focus()
      }
    }

    const editorFocus = () => {
      clearInterval(closeInterval);
      let vnode = document.getElementById(`${domId.value}`)
      let target = document.getElementById(`${qlpackId.value}`)
      let editorEleList = Array.from(document.getElementsByClassName('ck-balloon-panel'))
      const { top, left } = vnode?.getBoundingClientRect()
      let nodeTop = -40.5
      let nodeLeft = 0 // left + 400//editorEle?.offsetWidth
      // console.log(target)
      target?.setAttribute('style', `top:${nodeTop}px;left:${nodeLeft}px;position: absolute;`)
      editorEleList.forEach(item => {
        let options1 = {
          childList: true,
          attributes: true
        }
        let mb = new MutationObserver(function (mutationRecord, observer) {
          if(item?.offsetWidth && document.activeElement === vnode){
            let nodeLeft = item?.offsetWidth
            target?.setAttribute('style', `top:${nodeTop}px;left:${nodeLeft}px;position: absolute;`)
          }
        })
        mb.observe(item as HTMLElement, options1)
      })
      if(props?.formFocus){
        props.formFocus()
      }
    }

    onBeforeMount(() => {
      // console.log(domId.value)
    })

    onMounted(async () => {
      if (!app.dynamicInfoList?.length) {
        const res = await services.getTemplateDynamicInfo()
        commit('app/commonMutations', { dynamicInfoList: res.data })
      }
      options.value = app.dynamicInfoList?.map((item) => {
        let lsobj = {}
        let children: any[] = []
        lsobj['label'] = item.businessName
        lsobj['value'] = item.businessName
        lsobj['disabled'] = surveyDetail?.dynamicEvent !== item.businessName
        item?.params?.forEach((element) => {
          if (!element.param.includes('userInfo')) {
            children.push({ label: element.paramName, value: element.param })
          }
        })
        lsobj['children'] = children
        return lsobj
      }).sort((a, b) => a.disabled - b.disabled)
      // instance?.proxy?.$refs?.specialDom?.quill.setSelection(
      //   content.value?.length,
      //   content.value?.length
      // )
      const ele = Array.prototype.slice.call(
        document.getElementsByClassName('qlCascader_certain')
      )
      ele?.forEach((item) => {
        item.addEventListener('focus', handleDynamicEventsfocus)
        // item.addEventListener('blur', handleDynamicEventsbBulr)
      })

      // if(window['editor']){
      //   editor = window['editor']
      // }else{
      editor = await window?.['InlineEditor'].create(document.querySelector(`#${domId.value}`), {
        initialData: initialData.value,
        placeholder: placeholder.value,
        fontSize: {
          options: ['default', 12, 16, 18, 20, 30, 32]
        },
        language: i18n.locale === 'en' ? 'en' : '',
        image: {
          insert: {
            type: 'inline',
          },
          toolbar: []
        },
        extraPlugins: [upload.myCustomUploadAdapterPlugin],
      })
      //   window['editor'] = editor
      // }

      editor.model.document.on('change:data', (e) => {
        content.value = editor.getData()
        props.handleUpdate(content.value)
        // editor.model.change(writer => {
        // console.log(editor.model.document.selection.getFirstPosition())
        // editor.model.insertContent(writer.createText('插入的文本'), editor.model.document.selection.getFirstPosition());
        // })
        // editor.model.insertContent(writer.createText('插入的文本', editor.model.document.selection.getFirstPosition()));
      })
      //以下为监听editor1的class变化
      let editor1 = document.getElementById(`${domId.value}`)
      let options1 = {
        attributes: true,//观察vnode属性
        attributeFilter: ['class']//只观察class属性
      }
      let mb = new MutationObserver(function (mutationRecord, observer) {
        if (editor1?.className.includes('ck-blurred')) {
          let target = document.getElementById(`${qlpackId.value}`)
          target?.setAttribute('style', `top:-300px;left:-300px;position:fixed`)
        }
      })
      mb.observe(editor1 as HTMLElement, options1)
    })

    return () => {
      return (
        <div class="rich_text">
          <div
            cols="80"
            id={`${domId.value}`}
            name="editor1"
            rows="10"
            onFocus={editorFocus}
            onBlur={(e) => { editBlur(e) }}
            onClick={clickToFocus}
          >
          </div>
          {
            needDynamicEvent.value &&
            <div class="qlCascader_pack" id={`${qlpackId.value}`} onMousedown={(e) => { labelMouseDown(e) }}>
              <span
                title={surveyDetail.dynamicEvent ? '' : tran('survy.dynamicEventTips')}
                class="qlCascader_label"
                onClick={triggleCascader}
              >{tran('survy.dynamicEvent')}
                <i
                  class={isShowCascader.value ? 'el-icon-caret-top' : 'el-icon-caret-bottom'}
                ></i></span>
              {isShowCascader.value &&
                <el-cascader-panel
                  ref="qlCascaderRef"
                  tabindex="-1"
                  class="qlCascader_certain"
                  value={dynamicEventsValue.value}
                  onInput={(value) => {
                    dynamicEventsValue.value = value
                  }}
                  options={options.value}
                  props={{ expandTrigger: 'hover' }}
                  onChange={handleDynamicEventsChange}
                ></el-cascader-panel>
              }
            </div>
          }
        </div>
      )
    }

  }
})
export default CommonTetxEdit
